module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-techo-76f10373de31b7465cb75351d57cefc3.jpg";